/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue';
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from 'axios'
Vue.prototype.$http = axios

// Global seoReady function for analytics tracking
window.seoReady = function () {
  debugger;
  // Track page view with current document title and URL
  analyticsService.trackPageView(
    document.title,
    window.location.pathname,
    window.location.href
  );
};

// Theme Configurations
import '../themeConfig.js'


// Algolia - Instant Search
import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'

// Analytics Service
import analyticsService from './services/analyticsService'

// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

Vue.prototype.$isMobile = false;
Vue.prototype.$isAnonymous = false;

// Make analytics service available globally
Vue.prototype.$analytics = analyticsService;
window.analyticsService = analyticsService;

UpdateSystemSettings()
  .then(config => {
    // Make config available globally
    if (config.hasOwnProperty("FeatureManagement")) {
      Vue.prototype.$systemSettings = config.FeatureManagement;
    }
    else {
      console.error("Failed to parse settings")
      Vue.prototype.$systemSettings = config;
    }

    // Initialize Vue app after config is loaded
    new Vue({
      router,
      store,
      i18n,
      acl,
      render: h => h(App)
    }).$mount('#app');
  })
  .catch(error => {
    // Still initialize the app but with default settings or error state
    Vue.prototype.$systemSettings = '';
    new Vue({
      router,
      store,
      i18n,
      acl,
      render: h => h(App)
    }).$mount('#app');
  });

async function UpdateSystemSettings() {
  
  return new Promise((resolve, reject) => {
    TCVelikClient.GetRelative("/api/admin/GetSystemSettings")
      .then(function (response) {
        if (response) {
          var jsonString = response.data;
          try {
            resolve(jsonString);
          } catch (e) {
            reject(new Error("Failed to parse settings: " + e.message));
          }
        } else {
          reject(new Error("No response received"));
        }
      })
      .catch(err => {
        reject(err || new Error("Unknown error occurred"));
      });
  });

}

